"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForTx = exports.deployContract = exports.addTransaction = exports.getTransaction = exports.getTransactionStatus = exports.getStorageAt = exports.getCode = exports.getBlock = exports.callContract = exports.getContractAddresses = void 0;
var axios_1 = __importDefault(require("axios"));
var json_1 = require("./utils/json");
var number_1 = require("./utils/number");
var starknet_1 = require("./utils/starknet");
var API_URL = 'https://alpha3.starknet.io';
var FEEDER_GATEWAY_URL = API_URL + "/feeder_gateway";
var GATEWAY_URL = API_URL + "/gateway";
/**
 * Gets the smart contract address on the goerli testnet.
 *
 * [Reference](https://github.com/starkware-libs/cairo-lang/blob/f464ec4797361b6be8989e36e02ec690e74ef285/src/starkware/starknet/services/api/feeder_gateway/feeder_gateway_client.py#L13-L15)
 * @returns starknet smart contract addresses
 */
function getContractAddresses() {
    return new Promise(function (resolve, reject) {
        axios_1.default
            .get(FEEDER_GATEWAY_URL + "/get_contract_addresses")
            .then(function (resp) {
            resolve(resp.data);
        })
            .catch(reject);
    });
}
exports.getContractAddresses = getContractAddresses;
/**
 * Calls a function on the StarkNet contract.
 *
 * [Reference](https://github.com/starkware-libs/cairo-lang/blob/f464ec4797361b6be8989e36e02ec690e74ef285/src/starkware/starknet/services/api/feeder_gateway/feeder_gateway_client.py#L17-L25)
 *
 * @param invokeTx - transaction to be invoked
 * @param blockId
 * @returns the result of the function on the smart contract.
 */
function callContract(invokeTx, blockId) {
    return new Promise(function (resolve, reject) {
        axios_1.default
            .post(FEEDER_GATEWAY_URL + "/call_contract?blockId=" + (blockId !== null && blockId !== void 0 ? blockId : 'null'), __assign({ signature: [] }, invokeTx))
            .then(function (resp) {
            resolve(resp.data);
        })
            .catch(reject);
    });
}
exports.callContract = callContract;
/**
 * Gets the block information from a block ID.
 *
 * [Reference](https://github.com/starkware-libs/cairo-lang/blob/f464ec4797361b6be8989e36e02ec690e74ef285/src/starkware/starknet/services/api/feeder_gateway/feeder_gateway_client.py#L27-L31)
 *
 * @param blockId
 * @returns the block object { block_id, previous_block_id, state_root, status, timestamp, transaction_receipts, transactions }
 */
function getBlock(blockId) {
    return new Promise(function (resolve, reject) {
        axios_1.default
            .get(FEEDER_GATEWAY_URL + "/get_block?blockId=" + (blockId !== null && blockId !== void 0 ? blockId : 'null'))
            .then(function (resp) {
            resolve(resp.data);
        })
            .catch(reject);
    });
}
exports.getBlock = getBlock;
/**
 * Gets the code of the deployed contract.
 *
 * [Reference](https://github.com/starkware-libs/cairo-lang/blob/f464ec4797361b6be8989e36e02ec690e74ef285/src/starkware/starknet/services/api/feeder_gateway/feeder_gateway_client.py#L33-L36)
 *
 * @param contractAddress
 * @param blockId
 * @returns Bytecode and ABI of compiled contract
 */
function getCode(contractAddress, blockId) {
    return new Promise(function (resolve, reject) {
        axios_1.default
            .get(FEEDER_GATEWAY_URL + "/get_code?contractAddress=" + contractAddress + "&blockId=" + (blockId !== null && blockId !== void 0 ? blockId : 'null'))
            .then(function (resp) {
            resolve(resp.data);
        })
            .catch(reject);
    });
}
exports.getCode = getCode;
// TODO: add proper type
/**
 * Gets the contract's storage variable at a specific key.
 *
 * [Reference](https://github.com/starkware-libs/cairo-lang/blob/f464ec4797361b6be8989e36e02ec690e74ef285/src/starkware/starknet/services/api/feeder_gateway/feeder_gateway_client.py#L38-L46)
 *
 * @param contractAddress
 * @param key - from getStorageVarAddress('<STORAGE_VARIABLE_NAME>') (WIP)
 * @param blockId
 * @returns the value of the storage variable
 */
function getStorageAt(contractAddress, key, blockId) {
    return new Promise(function (resolve, reject) {
        axios_1.default
            .get(FEEDER_GATEWAY_URL + "/get_storage_at?contractAddress=" + contractAddress + "&key=" + key + "&blockId=" + (blockId !== null && blockId !== void 0 ? blockId : 'null'))
            .then(function (resp) {
            resolve(resp.data);
        })
            .catch(reject);
    });
}
exports.getStorageAt = getStorageAt;
/**
 * Gets the status of a transaction.
 *
 * [Reference](https://github.com/starkware-libs/cairo-lang/blob/f464ec4797361b6be8989e36e02ec690e74ef285/src/starkware/starknet/services/api/feeder_gateway/feeder_gateway_client.py#L48-L52)
 *
 * @param txHash
 * @returns the transaction status object { block_id, tx_status: NOT_RECEIVED | RECEIVED | PENDING | REJECTED | ACCEPTED_ONCHAIN }
 */
function getTransactionStatus(txHash) {
    var txHashBn = (0, number_1.toBN)(txHash);
    return new Promise(function (resolve, reject) {
        axios_1.default
            .get(FEEDER_GATEWAY_URL + "/get_transaction_status?transactionHash=" + (0, number_1.toHex)(txHashBn))
            .then(function (resp) {
            resolve(resp.data);
        })
            .catch(reject);
    });
}
exports.getTransactionStatus = getTransactionStatus;
/**
 * Gets the transaction information from a tx id.
 *
 * [Reference](https://github.com/starkware-libs/cairo-lang/blob/f464ec4797361b6be8989e36e02ec690e74ef285/src/starkware/starknet/services/api/feeder_gateway/feeder_gateway_client.py#L54-L58)
 *
 * @param txHash
 * @returns the transacton object { transaction_id, status, transaction, block_id?, block_number?, transaction_index?, transaction_failure_reason? }
 */
function getTransaction(txHash) {
    var txHashBn = (0, number_1.toBN)(txHash);
    return new Promise(function (resolve, reject) {
        axios_1.default
            .get(FEEDER_GATEWAY_URL + "/get_transaction?transactionHash=" + (0, number_1.toHex)(txHashBn))
            .then(function (resp) {
            resolve(resp.data);
        })
            .catch(reject);
    });
}
exports.getTransaction = getTransaction;
function formatSignature(sig) {
    if (!sig)
        return [];
    try {
        return sig.map(function (x) { return (0, number_1.toBN)(x); }).map(function (x) { return x.toString(); });
    }
    catch (e) {
        return [];
    }
}
/**
 * Invoke a function on the starknet contract
 *
 * [Reference](https://github.com/starkware-libs/cairo-lang/blob/f464ec4797361b6be8989e36e02ec690e74ef285/src/starkware/starknet/services/api/gateway/gateway_client.py#L13-L17)
 *
 * @param tx - transaction to be invoked
 * @returns a confirmation of invoking a function on the starknet contract
 */
function addTransaction(tx) {
    var signature = tx.type === 'INVOKE_FUNCTION' && formatSignature(tx.signature);
    var contract_address_salt = tx.type === 'DEPLOY' && (0, number_1.toHex)((0, number_1.toBN)(tx.contract_address_salt));
    return new Promise(function (resolve, reject) {
        axios_1.default
            .post(GATEWAY_URL + "/add_transaction", (0, json_1.stringify)(__assign(__assign(__assign({}, tx), (Array.isArray(signature) && { signature: signature })), (contract_address_salt && { contract_address_salt: contract_address_salt }))), { headers: { 'Content-Type': 'application/json' } })
            .then(function (resp) {
            resolve(resp.data);
        })
            .catch(reject);
    });
}
exports.addTransaction = addTransaction;
/**
 * Deploys a given compiled contract (json) to starknet
 *
 * @param contract - a json object containing the compiled contract
 * @param address - (optional, defaults to a random address) the address where the contract should be deployed (alpha)
 * @returns a confirmation of sending a transaction on the starknet contract
 */
function deployContract(contract, constructorCalldata, addressSalt) {
    if (constructorCalldata === void 0) { constructorCalldata = []; }
    if (addressSalt === void 0) { addressSalt = (0, starknet_1.randomAddress)(); }
    var parsedContract = typeof contract === 'string' ? (0, json_1.parse)(contract) : contract;
    var contractDefinition = __assign(__assign({}, parsedContract), { program: (0, starknet_1.compressProgram)(parsedContract.program) });
    return addTransaction({
        type: 'DEPLOY',
        contract_address_salt: addressSalt,
        constructor_calldata: constructorCalldata,
        contract_definition: contractDefinition,
    });
}
exports.deployContract = deployContract;
function wait(delay) {
    return new Promise(function (res) { return setTimeout(res, delay); });
}
function waitForTx(txHash, retryInterval) {
    if (retryInterval === void 0) { retryInterval = 2000; }
    return __awaiter(this, void 0, void 0, function () {
        var onchain, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onchain = false;
                    _a.label = 1;
                case 1:
                    if (!!onchain) return [3 /*break*/, 4];
                    // eslint-disable-next-line no-await-in-loop
                    return [4 /*yield*/, wait(retryInterval)];
                case 2:
                    // eslint-disable-next-line no-await-in-loop
                    _a.sent();
                    return [4 /*yield*/, getTransactionStatus(txHash)];
                case 3:
                    res = _a.sent();
                    if (res.tx_status === 'ACCEPTED_ONCHAIN' || res.tx_status === 'PENDING') {
                        onchain = true;
                    }
                    else if (res.tx_status === 'REJECTED') {
                        throw Error('REJECTED');
                    }
                    else if (res.tx_status === 'NOT_RECEIVED') {
                        throw Error('NOT_RECEIVED');
                    }
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.waitForTx = waitForTx;
exports.default = {
    waitForTx: waitForTx,
    getContractAddresses: getContractAddresses,
    callContract: callContract,
    getBlock: getBlock,
    getCode: getCode,
    getStorageAt: getStorageAt,
    getTransactionStatus: getTransactionStatus,
    getTransaction: getTransaction,
    addTransaction: addTransaction,
    compressProgram: starknet_1.compressProgram,
    deployContract: deployContract,
};
